export const isApplePodcastUrl = (url: string) =>
  /^https:\/\/podcasts\.apple\.com\/.+\/podcast\/.+\/id\d+(\?i=\d+)?/.test(url);
